import { render, staticRenderFns } from "./ExamPaperResult.vue?vue&type=template&id=0e223e59&scoped=true"
import script from "./ExamPaperResult.vue?vue&type=script&lang=js"
export * from "./ExamPaperResult.vue?vue&type=script&lang=js"
import style0 from "./ExamPaperResult.vue?vue&type=style&index=0&id=0e223e59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e223e59",
  null
  
)

export default component.exports